// import React, { useEffect, useState } from "react";
// import { useLocation,NavLink } from "react-router-dom";
// import Cookies from "js-cookie";
// import Navigation from "../components/Navigation";
// import Sidebar from "../components/Sidebar";
// import base_url from "../config/Config";

// const LoanDocuments = () => {
//   const [documents, setDocuments] = useState([]);
//   const location = useLocation();
//   const token = Cookies.get("authToken");

//   const queryParams = new URLSearchParams(location.search);
//   const customerId = queryParams.get("customerId");

//   useEffect(() => {
//     if (!token || !customerId) return;

//     const fetchDocuments = async () => {
//       try {
//         const response = await fetch(
//           `${base_url}/api/s3/getCustomerDocuments?customerId=${customerId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         const data = await response.json();
//         setDocuments(data || []);
//       } catch (error) {
//         console.error("Error fetching documents:", error);
//       }
//     };

//     fetchDocuments();
//   }, [customerId, token]);

//   return (
//     <>
//       <div className="overviewsaa">
//         <h4>Customer View</h4>
//       </div>

//       <div className="navigationss mb-5">
//         <Navigation />
//       </div>

//       <div className="container-fluid">
//         <div className="row">
//           <div className="col-lg-2 col-md-2 sidebarnavigartion">
//             <div className="lmssidebar">
//               <Sidebar />
//             </div>
//           </div>

//           <div className="col-lg-10 col-md-10">
//             <div className="dashboardlms mt-5 text-center">
//               <div className="row">
//                 {/* Tabs */}
//                 <div className="col-md-12 col-lg-12">
//                   <div className="reportsanalyzier mb-3">
//                     <div className="row">
//                       <div className="col-lg-2 col-md-2">
//                         <div className="credit buttonandly">
//                         <NavLink to={`/headerfile/CreditReport?id=${customerId}`}><p>Credit Report</p></NavLink>
//                         </div>
//                       </div>
//                       <div className="col-lg-2 col-md-2">
//                         <div className="analyzier buttonandly">
//                          <NavLink to={`/headerfile/LoanAgreement?id=${customerId}`}><p>Loan Agreement</p></NavLink>
//                         </div>
//                       </div>
//                       <div className="col-lg-2 col-md-2">
//                         <div className="digitalfoot buttonandly">
//                           <p>Loan Product</p>
//                         </div>
//                       </div>
//                       <div className="col-lg-2 col-md-2">
//                         <div className="devicehistory buttonandly">
//                            <NavLink to={`/loanmaster/LoanList?customerId=${customerId}`}> <p>Loan Details</p></NavLink>
//                         </div>
//                       </div>
//                       <div className="col-lg-2 col-md-2">
//                         <div className="location buttonandly">
//                          <NavLink to={`/operation/ViewVerifiedCustomer?id=${customerId}`}><p>Customer View</p></NavLink>
//                         </div>
//                       </div>
//                       <div className="col-lg-2 col-md-2">
//                         <div className="businessverification buttonandly">
//                          <NavLink to={`/headerfile/NOC?id=${customerId}`}><p>NOC</p></NavLink>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <hr />

//                 {/* Document Section */}
//                 <div className="col-md-12 col-lg-12">
//                   <div className="personalhead text-justify">
//                     <p>Loan Documents</p>
//                   </div>
//                   <div className="dashboardlms phonedashbaord mt-3">
//                     <div className="row">
//                       {documents.length > 0 ? (
//                         documents.map((doc, index) => (
//                           <div className="col-md-4 col-lg-4 mb-4" key={index}>
//                             <div className="card shadow-sm">
//                               <a
//                                 href={doc.url}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                               >
//                                 <img
//                                   src={doc.url}
//                                   alt={`Document ${index + 1}`}
//                                   className="card-img-top"
//                                   style={{
//                                     height: "300px",
//                                     objectFit: "contain",
//                                     padding: "10px",
//                                     backgroundColor: "#fff",
//                                   }}
//                                   onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src = "/placeholder.png";
//                                   }}
//                                 />
//                               </a>
//                               <div className="card-body text-center">
//                                 <small className="text-muted text-truncate d-block">
//                                   {doc.fileName?.split("/").pop()}
//                                 </small>
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       ) : (
//                         <div className="col-md-12 text-center mt-5">
//                           <p>No documents found.</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//                 {/* End Document Section */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LoanDocuments;

// import React, { useEffect, useState } from "react";
// import { useLocation, NavLink } from "react-router-dom";
// import Cookies from "js-cookie";
// import Navigation from "../components/Navigation";
// import Sidebar from "../components/Sidebar";
// import base_url from "../config/Config";

// const LoanDocuments = () => {
//   const [documents, setDocuments] = useState([]);
//   const location = useLocation();
//   const token = Cookies.get("authToken");

//   const queryParams = new URLSearchParams(location.search);
//   const customerId = queryParams.get("customerId");

//   useEffect(() => {
//     if (!token || !customerId) return;

//     const fetchDocuments = async () => {
//       try {
//         const response = await fetch(
//           `${base_url}/api/s3/getCustomerDocuments?customerId=${customerId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         const data = await response.json();
//         setDocuments(data || []);
//       } catch (error) {
//         console.error("Error fetching documents:", error);
//       }
//     };

//     fetchDocuments();
//   }, [customerId, token]);

//   const updateDocumentStatus = async (documentId, status) => {
//     try {
//       const response = await fetch(`${base_url}/api/documents/update-status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           documentId,
//           customerId,
//           status,
//         }),
//       });

//       const message = await response.text();
//       alert(message);
//     } catch (err) {
//       console.error("Error updating status:", err);
//       alert("Failed to update document status");
//     }
//   };

//   const handleReupload = async (documentId, file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("documentId", documentId);

//     try {
//       const response = await fetch(`${base_url}/api/s3/reupload`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       const result = await response.text();
//       alert(result);
//     } catch (error) {
//       console.error("Reupload failed:", error);
//       alert("Reupload failed");
//     }
//   };



// import React, { useEffect, useState } from "react";
// import { useLocation, NavLink } from "react-router-dom";
// import Cookies from "js-cookie";
// import Navigation from "../components/Navigation";
// import Sidebar from "../components/Sidebar";
// import base_url from "../config/Config";

// const LoanDocuments = () => {
//   const [imageDocuments, setImageDocuments] = useState([]);
//   const [detailDocuments, setDetailDocuments] = useState([]);
//   const location = useLocation();
//   const token = Cookies.get("authToken");
//   const queryParams = new URLSearchParams(location.search);
//   const customerId = queryParams.get("customerId");

//   // Fetch image documents from S3
//   useEffect(() => {
//     if (!token || !customerId) return;

//     const fetchImageDocs = async () => {
//       try {
//         const response = await fetch(
//           `${base_url}/api/s3/getCustomerDocuments?customerId=${customerId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         const data = await response.json();
//         setImageDocuments(data || []);
//       } catch (error) {
//         console.error("Error fetching image documents:", error);
//       }
//     };

//     fetchImageDocs();
//   }, [customerId, token]);

//   // Fetch document details (status/id)
//   useEffect(() => {
//     if (!token || !customerId) return;

//     const fetchDetailDocs = async () => {
//       try {
//         const response = await fetch(
//           `${base_url}/api/documents/customer?customerId=${customerId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         const data = await response.json();
//         setDetailDocuments(data || []);
//       } catch (error) {
//         console.error("Error fetching detail documents:", error);
//       }
//     };

//     fetchDetailDocs();
//   }, [customerId, token]);

//   const updateDocumentStatus = async (documentId, status) => {
//     try {
//       const response = await fetch(`${base_url}/api/documents/update-status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ documentId, customerId, status }),
//       });

//       const message = await response.text();
//       alert(message);
//     } catch (err) {
//       console.error("Error updating status:", err);
//       alert("Failed to update document status");
//     }
//   };

//   const handleReupload = async (documentId, file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("documentId", documentId);

//     try {
//       const response = await fetch(`${base_url}/api/s3/reupload`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       const result = await response.text();
//       alert(result);
//     } catch (error) {
//       console.error("Reupload failed:", error);
//       alert("Reupload failed");
//     }
//   };

//   return (
//     <>
//       <div className="overviewsaa">
//         <h4>Customer View</h4>
//       </div>

//       <div className="navigationss mb-5">
//         <Navigation />
//       </div>

//       <div className="container-fluid">
//         <div className="row">
//           <div className="col-lg-2 col-md-2 sidebarnavigartion">
//             <div className="lmssidebar">
//               <Sidebar />
//             </div>
//           </div>

//           <div className="col-lg-10 col-md-10">
//             <div className="dashboardlms mt-5 text-center">
//               <div className="row">
                // {/* Tabs */}
                // <div className="col-md-12 col-lg-12">
                //   <div className="reportsanalyzier mb-3">
                //     <div className="row">
                //       <div className="col-lg-2 col-md-2">
                //         <div className="credit buttonandly">
                //           <NavLink to={`/headerfile/CreditReport?id=${customerId}`}><p>Credit Report</p></NavLink>
                //         </div>
                //       </div>
                //       <div className="col-lg-2 col-md-2">
                //         <div className="analyzier buttonandly">
                //           <NavLink to={`/headerfile/LoanAgreement?id=${customerId}`}><p>Loan Agreement</p></NavLink>
                //         </div>
                //       </div>
                //       <div className="col-lg-2 col-md-2">
                //         <div className="digitalfoot buttonandly">
                //           <p>Loan Product</p>
                //         </div>
                //       </div>
                //       <div className="col-lg-2 col-md-2">
                //         <div className="devicehistory buttonandly">
                //           <NavLink to={`/loanmaster/LoanList?customerId=${customerId}`}><p>Loan Details</p></NavLink>
                //         </div>
                //       </div>
                //       <div className="col-lg-2 col-md-2">
                //         <div className="location buttonandly">
                //           <NavLink to={`/operation/ViewVerifiedCustomer?id=${customerId}`}><p>Customer View</p></NavLink>
                //         </div>
                //       </div>
                //       <div className="col-lg-2 col-md-2">
                //         <div className="businessverification buttonandly">
                //           <NavLink to={`/headerfile/NOC?id=${customerId}`}><p>NOC</p></NavLink>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // </div>

                // <hr />

//                 {/* Document Section */}
//                 <div className="col-md-12 col-lg-12">
//                   <div className="personalhead text-justify">
//                     <p>Loan Documents</p>
//                   </div>
//                   <div className="dashboardlms phonedashbaord mt-3">
//                     <div className="row">
//                       {imageDocuments.length > 0 ? (
//                         imageDocuments.map((doc, index) => (
//                           <div className="col-md-4 col-lg-4 mb-4" key={index}>
//                             <div className="card shadow-sm">
//                               <a href={doc.url} target="_blank" rel="noopener noreferrer">
//                                 <img
//                                   src={doc.url}
//                                   alt={`Document ${index + 1}`}
//                                   className="card-img-top"
//                                   style={{
//                                     height: "300px",
//                                     objectFit: "contain",
//                                     padding: "10px",
//                                     backgroundColor: "#fff",
//                                   }}
//                                   onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src = "/placeholder.png";
//                                   }}
//                                 />
//                               </a>
//                               <div className="card-body text-center">
//                                 <small className="text-muted text-truncate d-block mb-2">
//                                   {doc.fileName?.split("/").pop()}
//                                 </small>

//                                 {/* Status Dropdown */}
//                                 <select
//                                   className="form-select form-select-sm mb-2"
//                                   value={doc.status}
//                                   onChange={(e) => {
//                                     const updatedStatus = parseInt(e.target.value);
//                                     updateDocumentStatus(doc.id, updatedStatus);
//                                   }}
//                                 >
//                                   <option value={1}>Pending</option>
//                                   <option value={2}>Verified</option>
//                                   <option value={3}>Unverified</option>
//                                 </select>

//                                 {/* Reupload only if Unverified (3) */}
//                                 {doc.status === 3 && (
//                                   <>
//                                     <input
//                                       type="file"
//                                       className="form-control form-control-sm mb-2"
//                                       onChange={(e) => handleReupload(doc.id, e.target.files[0])}
//                                     />
//                                     <small className="text-danger">Upload required (Unverified)</small>
//                                   </>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       ) : (
//                         <div className="col-md-12 text-center mt-5">
//                           <p>No documents found.</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//                 {/* End Document Section */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LoanDocuments;


import React, { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import Navigation from "../components/Navigation";
import Sidebar from "../components/Sidebar";
import base_url from "../config/Config";

const LoanDocuments = () => {
  const [imageDocuments, setImageDocuments] = useState([]);
  const location = useLocation();
  const token = Cookies.get("authToken");
  const queryParams = new URLSearchParams(location.search);
  const customerId = queryParams.get("customerId");

  // Fetch documents on mount
  useEffect(() => {
    if (!token || !customerId) return;

    const fetchImageDocs = async () => {
      try {
        const response = await fetch(
          `${base_url}/api/s3/getCustomerDocuments?customerId=${customerId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await response.json();
        setImageDocuments(data || []);
      } catch (error) {
        console.error("Error fetching image documents:", error);
      }
    };

    fetchImageDocs();
  }, [customerId, token]);

  // ✅ Update status in backend and local state
  const updateDocumentStatus = async (documentId, status) => {
    try {
      const response = await fetch(`${base_url}/api/documents/update-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ documentId, customerId, status }),
      });

      const message = await response.text();
      alert(message);

      // ✅ update local state without reshuffling
      setImageDocuments(prevDocs =>
        prevDocs.map(doc =>
          doc.documentId === documentId ? { ...doc, status } : doc
        )
      );
    } catch (err) {
      console.error("Error updating status:", err);
      alert("Failed to update document status");
    }
  };

  // ✅ Reupload document file
  const handleReupload = async (documentId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentId", documentId);

    try {
      const response = await fetch(`${base_url}/api/s3/reupload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.text();
      alert(result);

      // Optional: You could re-fetch documents here to reflect updated image
      // fetchImageDocs();

    } catch (error) {
      console.error("Reupload failed:", error);
      alert("Reupload failed");
    }
  };

  return (
    <>
      <div className="overviewsaa">
        <h4>Document View</h4>
      </div>

      <div className="navigationss mb-5">
        <Navigation />
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 col-md-2 sidebarnavigartion">
            <Sidebar />
          </div>

          <div className="col-lg-10 col-md-10">
            <div className="dashboardlms">
              <div className="row">
                {/* Tabs */}
                <div className="col-md-12 col-lg-12">
                  <div className="reportsanalyzier text-center mb-3">
                    <div className="row">
                      {[
                        { label: "Credit Report", path: "CreditReport" },
                        { label: "Loan Agreement", path: "LoanAgreement" },
                        { label: "Loan Product", path: "" },
                        { label: "Loan Details", path: "/loanmaster/LoanList" },
                        { label: "Customer View", path: "/operation/ViewVerifiedCustomer" },
                        { label: "NOC", path: "NOC" }
                      ].map((tab, i) => (
                        <div key={i} className="col-lg-2 col-md-2">
                          <div className={`${tab.label.toLowerCase().replace(" ", "")} buttonandly`}>
                            {tab.path ? (
                              <NavLink to={`${tab.path.includes("/") ? "" : "/headerfile/"}${tab.path}?id=${customerId}`}>
                                <p>{tab.label}</p>
                              </NavLink>
                            ) : (
                              <p>{tab.label}</p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>


                {/* Combined Document View */}
                <div className="col-12">
                  {/* <h5 className="text-start">Uploaded Documents</h5> */}
                  <div className="row mt-3">
                    {imageDocuments.length > 0 ? (
                      imageDocuments.map((doc, index) => {
                        const currentStatus = parseInt(doc.status || 1);

                        return (
                          <div className="col-md-4 col-lg-4 mb-4" key={index}>
                            <div className="card shadow-sm">
                              <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                <img
                                  src={doc.url}
                                  alt={doc.documentName || "Document"}
                                  className="card-img-top"
                                  style={{
                                    height: "300px",
                                    objectFit: "contain",
                                    padding: "10px",
                                    backgroundColor: "#fff",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/placeholder.png";
                                  }}
                                />
                              </a>
                              <div className="card-body text-start">
                                <strong>{doc.documentName || doc.fileName?.split("/").pop()}</strong><br />
                                <small className="text-muted">Created: {doc.createDate}</small><br />
                                <small className="text-muted">Last Updated: {doc.updateDate}</small>

                                <select
                                  className="form-select form-select-sm mt-2 mb-2"
                                  value={currentStatus}
                                  onChange={(e) =>
                                    updateDocumentStatus(doc.documentId, parseInt(e.target.value))
                                  }
                                >
                                  <option value={1}>Pending</option>
                                  <option value={2}>Verified</option>
                                  <option value={3}>Unverified</option>
                                </select>

                                {currentStatus === 3 && (
                                  <>
                                    <input
                                      type="file"
                                      className="form-control form-control-sm mb-2"
                                      onChange={(e) =>
                                        handleReupload(doc.documentId, e.target.files[0])
                                      }
                                    />
                                    <small className="text-danger">Upload required (Unverified)</small>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12 text-center">
                        <p>No uploaded documents found.</p>
                      </div>
                    )}
                  </div>
                </div>
                {/* End Combined Section */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanDocuments;

